import { FunctionComponent } from "react";
import { ChildNodeProps } from "@App/Components/atoms/common/childNodeProps";

interface HeadlineProps extends ChildNodeProps {
  type: "h1" | "h2";
}

export const Headline: FunctionComponent<HeadlineProps> = ({ type, children }: HeadlineProps) => {
  const Tag = type;
  return (
    <Tag
      className={`${type === "h1" && "text-2xl xs:text-3xl"} ${type === "h2" && "text-xl"} font-serif mb-3`}
    >
      {children}
    </Tag>
  );
};
